import type { ButtonElementProps } from 'common/tracking/dispatchTrackingEventGA4';
import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';

const enum Event {
  Click = 'product-list-view_click',
}

const enum ButtonText {
  LoadPrev = 'Load Previous',
  LoadMore = 'Load More',
}

interface TrackPaginationClickOptions {
  page: number;
  previous?: boolean;
}

interface PaginationData extends ButtonElementProps {
  page_number: number;
}

export const dispatchPaginationClickEvent = ({
  page,
  previous = false,
}: TrackPaginationClickOptions) =>
  dispatchTrackingEventGA4<PaginationData>({
    event: Event.Click,
    element: 'button',
    button_text: previous ? ButtonText.LoadPrev : ButtonText.LoadMore,
    page_number: page + 1,
  });
